export const measurementKeys = {
	construction: (constructionId: string | undefined) =>
		["measurements", constructionId] as const,
	onDate: (
		constructionId: string | undefined,
		stageId: string | undefined,
		measuredOn: string,
	) => ["measurements", constructionId, stageId, measuredOn] as const,
	latest: (constructionId: string | undefined) =>
		["measurements", "latest", constructionId] as const,
	histories: (constructionId: string | undefined) =>
		["measurements", "history", constructionId] as const,
	history: (constructionId: string | undefined, stageId: string | undefined) =>
		["measurements", "history", constructionId, stageId] as const,
};
